// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  INearbyHousesExplanationRequest,
  TNearbyHousesExplanationModel,
  IMappers,
  TNearbyHousesExplanationResponse,
  INearbyHousesExplanationResponse,
  INearbyHousesExplanationResponseError,
} from './types';

export const defaultConfig: TNearbyHousesExplanationModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'valuation-offer-history',
  pathApi: '/v1/nearby-houses-explanation/',
} as TNearbyHousesExplanationModel;

export function createNearbyHousesExplanationModel(
  parameters: INearbyHousesExplanationRequest,
): TNearbyHousesExplanationModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface INearbyHousesExplanationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: INearbyHousesExplanationRequest;
}

export async function fetchNearbyHousesExplanation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: INearbyHousesExplanationOptions<TResponse200, TResponse400>): Promise<
  TNearbyHousesExplanationResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createNearbyHousesExplanationModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as INearbyHousesExplanationResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as INearbyHousesExplanationResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TNearbyHousesExplanationResponse;
}
